import { Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { trainwellColor } from "src/theme/themePrimitives";

/**
 * Team avatar according to the specs. It should contain initials for the team name. The
 * caller is responsible for providing the initials, and setting the height and width.
 */
export const TeamAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: trainwellColor.primary1,
  color: trainwellColor.primary4,
  ...theme.typography.subtitle2,
}));
